<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<template>
  <div>
    <label v-if="title" class="vs-input--label">{{ title }}</label>
    <v-select
      :disabled="disabled"
      class="selectExample w-full"
      :value="selectedItem"
      @input="_input($event)"
      :options="items"
    ></v-select>
  </div>
</template>
<style>
</style>
<script>
import vSelect from "vue-select";
export default {
  name: "select-account",
  props: {
    value: {
      type: String,
    },
    userId: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showConsumerAccount: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "درگاه",
    },
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      selectedValue: this.value,
    };
  },
  computed: {
    _userId() {
      return (this.userId || "currentUser") + "";
    },
    items() {
      if (!this.$store.getters["account/items"][this._userId]) return [];
      if (this.showConsumerAccount)
        return this.$store.getters["account/items"][this._userId];
      else
        return this.$store.getters["account/items"][this._userId].filter(
          (x) => x.isMerchant
        );
    },
    selectedItem(){
      
        if (this.$store.getters["account/items"][this._userId])
          return this.$store.getters["account/items"][
            this._userId
          ].find((x) => x.value == this.value);
    }
  },
  watch: {
    items() {
      if (this.$store.getters["account/items"][this._userId])
        this.selectedItem = this.$store.getters["account/items"][
          this._userId
        ].find((x) => x.value == this.$attrs.value);
    },
    userId() {
      this.$store.dispatch("account/fetchItems", { userId: this._userId });
    },
  },
  methods: {
    _input(e) {
      this.value= e ? e.value : null;
      this.$emit("input", e ? e.value : null);
    },
  },
  mounted() {
    this.$store.dispatch("account/fetchItems", { userId: this._userId });
  },
};
</script>
